export default __webpack_public_path__ + "static/media/sayal-logo.8bdb8717.png";